import React from 'react';
import '../styles.css';
import logo from '../assets/logo.svg'; // caminho pra tua logo

export default function Home() {
  return (
    <section className="home" id="home">
      <div className="home-content">
        <img 
          src={logo} 
          alt="Amaratech" 
          className="home-logo" 
        />
        <p>Protegendo o futuro digital do seu negócio.</p>
      </div>
    </section>
  );
}
